import { type CompletionStatus } from "../../Flows/types/enums";
import { EntityType } from "../types";

export interface Record {
  entityType: EntityType;
  completionStatus?: CompletionStatus;
}

export const mapCompletionStatus = (record: Record): CompletionStatus | undefined => {
  const entitiesWithCompletionStatus = [
    EntityType.Flow,
    EntityType.Video,
    EntityType.Survey,
    EntityType.Assessment,
    EntityType.Event,
    EntityType.Pdf,
    EntityType.EmbeddedVideo,
  ];

  return record && entitiesWithCompletionStatus.includes(record.entityType) ? record.completionStatus : undefined;
};
